import { FinancialAdjustment } from '../../../../enums';
import { ICod } from '../cod.interface';

export interface ICodInternational extends ICod {
    financialAdjustmentRequest?: FinancialAdjustment;
    pgiWithin40Days?: boolean;
    additionalInfo?: string;
}
